import React from 'react';
import ReactDOM from 'react-dom';
import Webpage from './components/Webpage';
import 'bootstrap/dist/css/bootstrap.css';
import './static/styles/_base.scss';

let App = document.getElementById ('app');
ReactDOM.render (<Webpage />, App);
